export type HelpCategoryId =
  | 'getting-started'
  | 'daily'
  | 'catalog'
  | 'marketing'
  | 'website'
  | 'collaboration'
  | 'messaging'
  | 'finance'
  | 'shop-system'

export type HelpLocale = 'en' | 'zh-Hant' | 'zh-CN'

export type HelpArticleMeta = {
  id: string
  category: HelpCategoryId
  slug: string
  title: string
  summary: string
  dashboardPath?: string
  order: number
  locale: HelpLocale
  body: string
}

export const HELP_CATEGORY_ORDER: HelpCategoryId[] = [
  'getting-started',
  'daily',
  'catalog',
  'marketing',
  'website',
  'collaboration',
  'messaging',
  'finance',
  'shop-system',
]
